<template>
  <div class="container" style="width: 60%;">
    <div style="margin-top: 20px; margin-bottom: 20px; float: right;">
      <button
        type="submit"
        style="background: none; border: none;"
        tag="a"
        v-on:click="submit"
      >
        <div class="btn btn-create">
          Submit Provider
        </div>
      </button>
    </div>
    <h4>Provider Details</h4>
    <display />
    <div style="margin-top: 50px; float: right;">
      <button
        type="submit"
        style="background: none; border: none;"
        tag="a"
        v-on:click="submit"
      >
        <div class="btn btn-create">
          Submit Provider
        </div>
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import display from "../elements/display.vue";

export default {
  name: "submit-page",
  components: {
    display: display
  },
  methods: {
    submit() {
      this.$store.dispatch("addMessage", {
        text: "Provider successfully uploaded.",
        type: "info",
        duration: 5000
      });
      this.$store.commit("setNullMode");
      window.scrollTo(0, 0);
      if (!this.$store.getters.oneTimeAccess) {
        this.$router.push({ name: "search" });
      }
    }
  }
};
</script>

<style>
input[type="text"],
select,
textarea {
  width: 100%;
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  margin-top: 6px;
  margin-bottom: 16px;
  resize: vertical;
}
.container {
  padding: 20px;
}
<style scoped > table {
  border-collapse: collapse;
  width: 100%;
}
td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}
tr:nth-child(even) {
  background-color: #eaeaea;
}
</style>



// WEBPACK FOOTER //
// src/components/submitPage.vue